import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const CrossIcon: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fill="#fff"
            d="M19.849 5.848 13.697 12l6.152 6.15-1.698 1.698L12 13.697l-6.151 6.151-1.698-1.697L10.303 12 4.15 5.848 5.85 4.151 12 10.302l6.151-6.151 1.698 1.697Z"
        />
    </svg>
);
